import { fetchAction } from 'src/redux/actions';
import { urls } from 'src/urls/source';

import { FetchSourceObjectMeta } from './';

// eslint-disable-next-line import/no-default-export
export default (repoFullName: string, ref: string, path: string) =>
  fetchAction(FetchSourceObjectMeta, {
    url: urls.api.v20.source(repoFullName, ref, path, {
      format: 'meta',
    }),
    fetchOptions: {
      errorType: 'text',
    },
  });
